// extracted by mini-css-extract-plugin
export default {"container":"FloorPlansPage_container__kQv-T"};